import { BuildConfig } from './build-config';

export const environment: BuildConfig = {
    baseUrl: 'https://lib.maeen-library.com',
    auth: {
        username: 'anasser',
        password: 'Ahmnas@1976'
    },
    homePageVersion: 'new',
};
